import { render } from "./event.vue?vue&type=template&id=5d39d492&scoped=true"
import script from "./event.vue?vue&type=script&lang=js"
export * from "./event.vue?vue&type=script&lang=js"

import "./event.vue?vue&type=style&index=0&id=5d39d492&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d39d492"]])

export default __exports__